import { Fragment, ReactElement } from "react";

import {
  Box,
  SimpleGrid,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";

import { ExpansionRow } from "./SortableDynamicTable";
import ExpansionRowStat from "./ExpansionRowStat";

export const BACK_TO_TOP_MIN_LINES = 10;

const MobileSortableCardTable = ({
  values,
  columns,
  hasExpansionRow,
}: {
  values:
    | ContractTerms
    | any
    | (ContractTerms & { expansionRow: ExpansionRow[] }); // update typing here and on line with values.map
  columns: ColumnDefinition<any>[];
  hasExpansionRow?: boolean;
}): ReactElement => (
  <Table
    variant="unstyled"
    colorScheme={undefined}
    style={{
      borderCollapse: "separate",
      borderSpacing: hasExpansionRow ? "0 2px" : "0 16px",
    }}
  >
    <Tbody>
      {values.map((term: any) => (
        <Fragment key={term.docEntry}>
          <SimpleGrid
            as={Tr}
            columns={2}
            spacing={4}
            p={4}
            mb={hasExpansionRow && term.rowExpanded ? undefined : "24px"}
            style={{
              boxShadow: "0px 0px 4px grey",
              borderRadius: "4px",
            }}
          >
            {columns.map((column) => (
              <Stack as={Td} key={column.property} p={0} spacing={1}>
                <Text
                  textStyle="body2"
                  color="grey.500"
                  fontWeight="medium"
                  whiteSpace="nowrap"
                >
                  {column.columnLabel}
                </Text>
                <Box textOverflow="ellipsis" overflow="hidden">
                  <Text
                    textStyle="body2"
                    whiteSpace="nowrap"
                    noOfLines={1}
                    as="span"
                    display="inline"
                  >
                    {term[column.property] as string}
                  </Text>
                </Box>
              </Stack>
            ))}
          </SimpleGrid>
          {hasExpansionRow && term.rowExpanded && (
            <SimpleGrid
              as={Tr}
              columns={2}
              spacing={4}
              bgColor="grey.50"
              px={4}
              py={6}
              mb={4}
            >
              {(term.expansionRow as ExpansionRow[]).map((column, index) => (
                <ExpansionRowStat
                  as={Td}
                  key={column.label ?? `column-${index}`}
                  label={column.label}
                  value={column.value}
                  p={0}
                  gridColumn={`span ${column.mobileSpan ?? 1}`}
                  alignItems={column.mobileAlign ?? "flex-start"}
                />
              ))}
            </SimpleGrid>
          )}
        </Fragment>
      ))}
    </Tbody>
  </Table>
);

export default MobileSortableCardTable;
